import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { logEvent } from '~/config/firebase.config';
import { Button } from '~/components/ui/button';
import { FreeTrialTimeline } from './FreeTrialTimeline';

import styles from './FreeTrial.module.css';

export function FreeTrial() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    useEffect(() => {
        logEvent('screen_view', 'FreeTrialPopup');
    }, []);

    return (
        <div className={styles.container}>
            <h1>
                <Trans i18nKey="freeTrial.title">
                    Go further with <span className={styles.important}>14 days free trial</span>!
                </Trans>
            </h1>
            <div className={styles.content}>
                <FreeTrialTimeline />
                <p style={{ textAlign: 'center' }}>
                    {t('freeTrial.description')}
                    <br />
                    <b>{t('freeTrial.price')}</b>
                </p>

                <Button
                    className={styles.margin}
                    onClick={() => logEvent('button_click', 'FreeTrialPopup', () => navigate('/signup'))}
                >
                    {t('freeTrial.button')}
                </Button>
            </div>
        </div>
    );
}
